var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4536 11.3752V2.37524H2.45361V11.3752M4.45361 9.37524V4.37524H9.45361V9.37524M20.4536 6.87524C20.4536 8.27524 19.3536 9.37524 17.9536 9.37524C16.5536 9.37524 15.4536 8.27524 15.4536 6.87524C15.4536 5.47524 16.5636 4.37524 17.9536 4.37524C19.3436 4.37524 20.4536 5.48524 20.4536 6.87524ZM6.95361 14.3752L2.45361 22.3752H11.4536M8.03361 20.3752H5.87361L6.95361 18.4552M22.4536 6.87524C22.4536 4.37524 20.4536 2.37524 17.9536 2.37524C15.4536 2.37524 13.4536 4.37524 13.4536 6.87524C13.4536 9.37524 15.4536 11.3752 17.9536 11.3752C20.4536 11.3752 22.4536 9.37524 22.4536 6.87524ZM19.4536 17.3752V14.3752H17.4536V17.3752H14.4536V19.3752H17.4536V22.3752H19.4536V19.3752H22.4536V17.3752H19.4536Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.87f6f20b5934b9d07202712e7589ddf1.svg";
export { ForwardRef as ReactComponent };